import React from 'react';
import Header from './Header';

const cardsVendas = [
  {
    nome: 'Pedidos',
    key: 'pedidos',
    icon: (
      <svg className="w-8 h-8 mb-2 text-blue-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 7h18M3 12h18M3 17h18" />
      </svg>
    )
  },
  {
    nome: 'Atendimentos',
    key: 'atendimentos',
    icon: (
      <svg className="w-8 h-8 mb-2 text-green-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    )
  },
  {
    nome: 'NFC-e',
    key: 'nfce',
    icon: (
      <svg className="w-8 h-8 mb-2 text-yellow-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M3 10h18" />
        <path d="M9 14h1m4 0h1" />
      </svg>
    )
  }
];

function MenuVendasPage({ usuario, empresaSelecionada, handleVoltar, handleSair, onSelecionarMenuVendas }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header
        usuario={usuario}
        empresa={empresaSelecionada}
        onVoltar={handleVoltar}
        onSair={handleSair}
      />
      <div className="flex flex-col items-center justify-center mt-16">
        <div className="bg-white p-10 rounded-2xl shadow-2xl w-full max-w-2xl border border-blue-100 flex flex-col items-center">
          <h2 className="text-2xl font-bold text-blue-700 mb-8">Vendas</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full">
            {cardsVendas.map(card => (
              <div
                key={card.key}
                className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300"
                onClick={() => onSelecionarMenuVendas && onSelecionarMenuVendas(card.key)}
              >
                {card.icon}
                <span className="text-lg font-semibold text-blue-800">{card.nome}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MenuVendasPage; 